// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { LegacyAssetsOut } from './legacyAssetsOut.zod.ts';
import { MatchedAssetsOut } from './matchedAssetsOut.zod.ts';
import { NotEvaluatedAssetsOut } from './notEvaluatedAssetsOut.zod.ts';
import { PersonRef } from './personRef.zod.ts';
import { ReportSectionOut } from './reportSectionOut.zod.ts';

export const ResearchOut = zod.object({
  "assets_evaluated": zod.boolean(),
  "assets_used": zod.union([zod.union([MatchedAssetsOut,NotEvaluatedAssetsOut,LegacyAssetsOut]),zod.null()]).optional(),
  "confidence": zod.union([zod.int(),zod.null()]),
  "created_at": zod.iso.datetime({"offset":true}),
  "dimensions": zod.union([zod.array(zod.record(zod.string(), zod.unknown())),zod.null()]),
  "error": zod.union([zod.string(),zod.null()]),
  "finished_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "id": zod.uuid(),
  "industry_fit": zod.union([zod.record(zod.string(), zod.unknown()),zod.null()]),
  "model_key": zod.union([zod.string(),zod.null()]),
  "model_name": zod.union([zod.string(),zod.null()]).optional(),
  "prompt_version": zod.union([zod.string(),zod.null()]),
  "prompt_version_number": zod.union([zod.int(),zod.null()]),
  "rationale": zod.union([zod.string(),zod.null()]),
  "refinement": zod.union([zod.string(),zod.null()]).optional(),
  "report": zod.array(ReportSectionOut),
  "requested_by": zod.union([PersonRef,zod.null()]),
  "scores": zod.record(zod.string(), zod.union([zod.int(),zod.null()])),
  "started_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "status": zod.enum(['queued', 'running', 'succeeded', 'failed']),
  "summary": zod.union([zod.string(),zod.null()]),
  "total": zod.union([zod.number(),zod.null()]),
  "verdict": zod.union([zod.enum(['go', 'conditional_go', 'no_go']),zod.null()])
});

export type ResearchOut = zod.input<typeof ResearchOut>;
export type ResearchOutOutput = zod.output<typeof ResearchOut>;
